// Helper to render images stored in Emergent object storage.
// Backend stores `image_url` like "/api/files/h2-maint/uploads/.../<uuid>.png".
// <img src> can't send headers, so we append the JWT as ?auth=<token>.
// Pass { thumb: true } on listing pages to get a low-fidelity ~400px JPEG (~10–60 KB).
// Legacy Base64 data URLs and absolute URLs are passed through unchanged.

// When REACT_APP_BACKEND_URL is unset, fall back to a relative URL so
// <img src> always inherits the page's protocol + host. See App.js for the
// reasoning -- prevents mixed-content errors in production.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function imgSrc(url, options = {}) {
  if (!url) return '';
  // Pass through legacy base64/data URLs and externally-hosted images.
  if (url.startsWith('data:') || /^https?:\/\//i.test(url)) {
    return url;
  }
  const token = localStorage.getItem('token');
  const base = url.startsWith('/') ? `${BACKEND_URL}${url}` : `${BACKEND_URL}/${url}`;
  const params = new URLSearchParams();
  if (token) params.set('auth', token);
  if (options.thumb) params.set('size', 'thumb');
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
